import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useStore } from "../state/store";
import { Lobby } from "./Lobby";
import { Table } from "./table/Table";

export function LobbyRoute() {
  const code = useParams().code!.toUpperCase();
  const navigate = useNavigate();
  const seated = useStore((s) => s.code);
  const lobby = useStore((s) => s.lobby);
  const game = useStore((s) => s.game);
  const rejoin = useStore((s) => s.rejoin);
  const wasSeated = useRef(false);
  const [backToLobby, setBackToLobby] = useState(false);

  // Reclaim the seat with a stored token, or go home to join by name.
  useEffect(() => {
    if (useStore.getState().code !== code && !rejoin(code)) {
      const params = new URLSearchParams(location.search);
      params.set("code", code);
      navigate(`/?${params}`, { replace: true });
    }
  }, [code, rejoin, navigate]);

  // Losing the seat (kicked, expired token, leaving) returns home.
  useEffect(() => {
    if (seated === code) wasSeated.current = true;
    else if (wasSeated.current && !seated) navigate(`/?code=${code}`, { replace: true });
  }, [seated, code, navigate]);

  const phase = lobby?.phase;
  if (phase === "playing" && backToLobby) setBackToLobby(false);

  if (!lobby || seated !== code) {
    return <div style={{ padding: 40, color: "var(--muted)" }}>Connecting…</div>;
  }
  // Players in the match and spectators watch the table; anyone seated after it began waits in the lobby.
  const watching =
    game?.view.players.some((p) => p.id === game.view.you) ||
    lobby.spectators.some((s) => s.id === game?.view.you);
  if (phase !== "lobby" && game && watching && !backToLobby) {
    return <Table onBackToLobby={() => setBackToLobby(true)} />;
  }
  return <Lobby />;
}
